
import URI from 'urijs';
import { combineReducers } from 'redux';

import auth from '../common/client/reducers/auth';
import operationStatus from '../common/client/reducers/operationStatus';

import { SET_PROJECT_ID, SET_UI_VALUE } from './saga';

import { reducer as dataReducer } from '../data';
import { reducer as mapReducer } from '../map';
import { reducer as measurementReducer } from '../measurement';
import { reducer as mapMultiSceneReducer } from '../mapmultiscene';
import { reducer as multiSceneReducer } from '../multiscene';
import { reducer as printReducer } from '../print';
import { reducer as projectReducer } from '../project';
import { reducer as searchReducer } from '../search';
import { reducer as shareReducer } from '../share';

const initialState = {
    uiValues: {},
    urlParams: getParamsFromUrl()
};

function getParamsFromUrl() {
    let uri = new URI(window.location.href);
    return uri.search(true);
}

function app(state = initialState, action) {
    switch (action.type) {
        case SET_PROJECT_ID:
            return {
                ...state,
                projectId: action.projectId
            };
        case SET_UI_VALUE:
            return {
                ...state,
                uiValues: {
                    ...state.uiValues,
                    [action.name]: action.value
                }
            };

        default:
            return state;
    }
}

export default combineReducers({
    app,
    auth,
    operationStatus,
    data: dataReducer,
    map: mapReducer,
    measurement: measurementReducer,
    mapMultiScene: mapMultiSceneReducer,
    multiScene: multiSceneReducer,
    print: printReducer,
    project: projectReducer,
    search: searchReducer,
    share: shareReducer
});
